import {
	Component,
	Input,
	Output,
	EventEmitter,
	SimpleChanges,
	ViewChild,
	OnChanges,
	input,
	signal,
	effect,
	inject,
} from '@angular/core';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { DriversModalInfoComponent } from './drivers-modal-info/drivers-modal-info.component';
import { DriversSalaryPaymentsComponent } from './drivers-salary-payments/drivers-salary-payments.component';
import { DateService } from 'src/app/common/date.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DriverSalarySummary } from '@/drivers/driver.model';
import { DriverSalary } from '@/drivers/drivers-salary-common/drivers-salary-month-list/drivers-salary-month-list.component';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, take } from 'rxjs';
import { DriversModalConfirmationComponent } from '@/drivers/drivers-salary-common/drivers-salary-summary-month/drivers-modal-confirmation/drivers-modal-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

export enum SettlementKindsNames {
	FLIX = 'Flix',
	MOBILITY = 'Pakiet Mobilności',
}

@Component({
	selector: 'app-drivers-salary-summary-month',
	templateUrl: './drivers-salary-summary-month.component.html',
})
export class DriversSalarySummaryMonthComponent implements OnChanges {
	@ViewChild(DriversModalInfoComponent)
	DriversModalInfoComponent: DriversModalInfoComponent;
	@ViewChild(DriversSalaryPaymentsComponent)
	DriversSalaryPaymentsComponent: DriversSalaryPaymentsComponent;
	@Input() driverDays: Array<any>;
	@Input() driver;
	@Input() bonus: Array<any>;
	@Input() salary: Array<any>;
	@Input() editable;
	@Input() salaryData = null;
	readonly selectedMonth = input.required<string>();
	@Output() changeMonth = new EventEmitter();
	@Output() sendHistoryConfirmed = new EventEmitter();
	driversSalaryPayments: Array<any>;
	sendData;
	caluclateCount = 0;
	showDuplicates = '';
	summary: DriverSalarySummary = {
		rates: 0,
		benefits: 0,
		deductions: 0,
		bonusNegative: [],
		bonusPositive: [],
		diets: 0,
		mobility: 0,
		cash: 0,
		cashEuro: 0,
		transfer: 0,
		payments: 0,
		paymentsEuro: 0,
		confirmedDays: false,
		sumMonth: 0,
		sumMonthEuro: 0,
	};
	ratesInfo;
	flixRatesInfo;
	data = {
		id: null,
		month: null,
		driver: null,
		basicSalary: 0,
		salary: null,
		confirmedDays: false,
		comment: null,
		payment: null,
	};

	readonly dialog = inject(MatDialog);
	readonly driverSalarySummary = signal<DriverSalary>(null);

	protected lastUserConfirmed = {
		userName: null,
		date: null,
	};
	bonusSum = 0;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly auth: AuthService,
		private readonly date: DateService,
		private readonly route: ActivatedRoute,
	) {
		effect(() => this.getDriverSalarySummary());

		// I know this is a poor solution, and it would be better to create computed signal for summary,
		// but I'm afraid to touch the more sensitive code that is in this component
		effect(() => {
			if (this.driverSalarySummary()) {
				this.data.basicSalary = this.driverSalarySummary().basicSalary.converted_pln;
				this.summary.sumMonth = this.driverSalarySummary().sumAll.converted_pln;
				this.summary.sumMonthEuro = this.driverSalarySummary().sumAll.EUR;
				this.summary.diets = this.driverSalarySummary().diets.converted_pln;
				this.summary.mobility = this.driverSalarySummary().mobilityPackage.converted_pln;
				this.summary.rates = this.driverSalarySummary().sumRates.converted_pln;
				this.summary.benefits = this.driverSalarySummary().sumBenefits.converted_pln;
				this.summary.deductions = this.driverSalarySummary().sumDeduction.converted_pln;
				this.summary.transfer = this.driverSalarySummary().transfer.converted_pln;
				this.summary.cash = this.driverSalarySummary().cash.converted_pln;
				this.summary.cashEuro = this.driverSalarySummary().cash.EUR;
				this.summary.payments = this.driverSalarySummary().leftToPay.converted_pln;
				this.summary.paymentsEuro = this.driverSalarySummary().leftToPay.EUR;
			}
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && this.driver.first_name && this.driverDays && this.bonus && this.salary) {
			this.getPayments();
			if (!changes.editable) {
				this.data = {
					id: null,
					month: null,
					driver: null,
					basicSalary: 0,
					salary: null,
					confirmedDays: false,
					comment: null,
					payment: null,
				};
				this.bonusSum = 0;
				this.loadDuplicateRateInfo();
				this.convertData(this.salary);
				this.getLastUser();
			}
		}
	}

	getLastUser(): void {
		this.api.get(`/driver/driverSalaryConfirmHistory?positionId=${this.data.id}`, (result, error) => {
			this.sendHistoryConfirmed.emit(result.data);
			this.lastUserConfirmed = result.data[0];
		});
	}

	getPayments(): void {
		const parms = `driver=${this.driver.id}&date=${this.salaryData}`;
		this.api.get(`/driversSalaryPayments?${parms}`, (result, error) => {
			this.driversSalaryPayments = result.data;
			this.countRates();
		});
	}

	protected checkDuplicateRate(summary): void {
		const parameters = {
			calculateDays: null,
			days: null,
			hasDuplicates: null,
		};
		parameters.calculateDays = this.driverDays.filter((obj) => obj.isCalculate === true);
		parameters.days = new Set(parameters.calculateDays.map((obj) => obj.day));
		parameters.hasDuplicates = parameters.days.size < parameters.calculateDays.length;
		if (parameters.hasDuplicates && !summary.confirmedDays) {
			this.infobox.error('Kierowca ma przypisaną podwójną dniówkę, zweryfikuj');
		}
	}

	protected loadDuplicateRateInfo(): string {
		const parameters = {
			calculateDays: null,
			days: null,
			hasDuplicates: null,
		};
		parameters.calculateDays = this.driverDays.filter((obj) => obj.isCalculate === true);
		parameters.days = new Set(parameters.calculateDays.map((obj) => obj.day));
		parameters.hasDuplicates = parameters.days.size < parameters.calculateDays.length;
		if (parameters.hasDuplicates) {
			return (this.showDuplicates = 'W wynagrodzeniach są zaznaczone podwójne dni');
		}
		return (this.showDuplicates = '');
	}

	submit(): void {
		const data = {
			month: this.salaryData,
			driver: this.driver.id,
			basicSalary: this.data.basicSalary,
			comment: this.data.comment,
		};
		this.api.command(`/driversSalaryDays/`, { cmd: 'saveSalaryInfo', set: data }, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Zapisano zmiany.');
			this.data.id = result.data;
		});
		this.getDriverSalarySummary(); //adding to refresh the data from backend calculations, as calculations performed by frontend have been removed
	}

	confirmedSalary(confirm: boolean): void {
		const driver = this.driver.id;
		const hasGrosze = !Number.isInteger(this.summary.cashEuro) || !Number.isInteger(this.summary.cash);
		const roundUp$: Observable<boolean> =
			hasGrosze && confirm
				? this.dialog.open(DriversModalConfirmationComponent, { width: '420px' }).afterClosed()
				: of(false);

		roundUp$.subscribe((ceilFinalValue) => {
			this.api.command(
				`/driverSalarySummary/${driver}`,
				{
					cmd: 'confirm',
					set: {
						month: this.salaryData,
						driver,
						confirm,
						ceilFinalValue,
					},
				},
				(result, error) => {
					if (error) {
						return;
					}
					const successMessage = confirm
						? 'Wynagrodzenie zostało zatwierdzone.'
						: 'Usunieto zatwierdzenie wynagrodzenia.';
					this.infobox.success(successMessage);
					this.data.confirmedDays = confirm;
					this.getLastUser(); //to refresh displayed date confirmation
					if (ceilFinalValue) {
						// if the user confirmed the roundUp, the summary will have changed, and we need to refresh the data from backend calculations, as calculations performed by frontend have been removed
						this.getDriverSalarySummary();
					}
				},
			);
		});
	}

	infoRatesOpen(type: string): void {
		switch (type) {
			case 'rates':
				this.DriversModalInfoComponent.showSalaryInfo();
				break;
			case 'bonusPositive':
				this.DriversModalInfoComponent.showBonusPositive();
				break;
			case 'bonusNegative':
				this.DriversModalInfoComponent.showBonusNegative();
				break;
		}
	}

	paymentsModal(): void {
		this.sendData = this.driversSalaryPayments;
		this.DriversSalaryPaymentsComponent.dialogOpen();
	}

	protected countRates(): void {
		this.caluclateCount = 0;
		this.ratesInfo = this.driverDays
			.filter((obj) => obj.isCalculate)
			.reduce((a, b) => {
				const i = a.findIndex((x) => x.value === b.salary && x.rateKind === b.rateKind_name);
				if (i === -1) {
					const rateKind_name = b.rateKind_name;
					a.push({
						value: b.salary,
						rateKind: rateKind_name,
						times: 1,
					});
				} else {
					a[i].times++;
				}
				return a;
			}, []);
		this.flixRatesInfo = this.bonus
			.filter((obj) => obj.name === SettlementKindsNames.FLIX)
			.reduce((a, b) => {
				const i = a.findIndex((x) => x.value === b.value);
				if (i === -1) {
					const name = b.name;
					a.push({
						value: b.value,
						rateKind: name,
						times: 1,
					});
				} else {
					a[i].times++;
				}
				return a;
			}, []);
		this.ratesInfo.forEach((obj) => {
			return (obj.rateKind = !obj.rateKind ? 'Brak' : obj.rateKind);
		});
		this.flixRatesInfo.forEach((obj) => {
			return (obj.rateKind = !obj.rateKind ? 'Brak' : obj.rateKind);
		});
		this.driverDays
			.filter((obj) => !obj.isCalculate)
			.forEach((obj) => {
				this.caluclateCount += 1;
			});
	}

	protected convertData(data): void {
		data.forEach((obj) => {
			obj.confirmedDays = obj.confirmedDays == '1' ? true : false;
			this.data = obj;
		});
		return data;
	}

	protected getDriverSalarySummary(): void {
		this.route.params.pipe(take(1)).subscribe((params) => {
			const driverId = params['id'];
			if (!driverId) {
				return;
			}
			this.api.get(
				`/driverSalarySummary?month=${this.selectedMonth()}&driver=${driverId}`,
				(result: { data: DriverSalary; error: unknown; errorCode: unknown }, error) => {
					if (error) {
						return;
					}
					this.driverSalarySummary.set(result.data);
				},
			);
		});
	}
}
